var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"page-loader"},[_c('span',{staticStyle:{"position":"relative","top":"50%"}},[_c('Spin',{attrs:{"size":"large","fix":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }